<div class="min-h-screen w-full flex flex-col">
  <app-header></app-header>
  <app-toolbar></app-toolbar>
  <app-submenu [items]="subMenuItems"></app-submenu>


  <div class="mx-7 mt-4 h-full" id="container">
    <p-toast></p-toast>

    <!---------------------------------------------MODAL CLIENTE------------------------------------------------>
    <p-dialog [modal]="true" [(visible)]="formSteps['customerDataForm']" [style]="{width: '35vw'}"
      header="Titular de la reserva">
      <form [formGroup]="formCustomer">
        <ng-template pTemplate="header">
          <h4 class="text-[#27368A] font-extrabold text-xl flex place-items-center">
            Datos del titular de la reserva
          </h4>
        </ng-template>
        <div class="flex flex-col  justify-center">
          <p-autoComplete [tabindex]="1" #searcherAutocomplete [suggestions]="results" [showClear]="true" [virtualScrollItemSize]="50"
            (completeMethod)="searchCustomer($event)" (onSelect)="onSelect($event)" styleClass="w-full" field="name"
            value="name"
            inputStyleClass="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 w-full px-2 mb-2 "
            placeholder="Buscar cliente">
            <ng-template let-item pTemplate="itemTemplate">
              <div class="autocomplete-item">
                <h3>{{item.name}}</h3>
                <span class="text-xs text-gray-700">{{item.email}}</span>
              </div>
            </ng-template>
          </p-autoComplete>
          <div class="mb-2">
            <label for="name" class="text-[#27368A] font-bold text-base">
              Nombre completo:
            </label>
            <input
              [ngClass]="{'border-red-600' : formCustomer.get('name')?.touched && formCustomer.get('name')?.hasError('required')}"
              formControlName="name" type="text" placeholder="Nuevo Cliente" tabindex="2"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formCustomer.controls['name'].touched">
              <p *ngIf="formCustomer.get('name')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <div class="mb-2">
            <label for="cif" class="text-[#27368A] font-bold text-base">
              Documento Identificación:
            </label>
            <input
              [ngClass]="{'border-red-600' : formCustomer.get('cif')?.touched && formCustomer.get('cif')?.hasError('required')}"
              formControlName="cif" type="text" placeholder="DNI/CIF/NIE" tabindex="3"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formCustomer.controls['cif'].touched">
              <p *ngIf="formCustomer.get('cif')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <div class="mb-2">
            <label for="phone" class="text-[#27368A] font-bold text-base">
              Teléfono:
            </label>
            <input
              [ngClass]="{'border-red-600' : formCustomer.get('phone')?.touched && formCustomer.get('phone')?.hasError('required')}"
              formControlName="phone" type="text" placeholder="teléfono" tabindex="4"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formCustomer.controls['phone'].touched">
              <p *ngIf="formCustomer.get('phone')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <div class="mb-2">
            <label for="email" class="text-[#27368A] font-bold text-base">
              Email:
            </label>
            <input
              [ngClass]="{'border-red-600' : formCustomer.get('email')?.touched && formCustomer.get('email')?.hasError('required')}"
              formControlName="email" type="email" placeholder="email" tabindex="5"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formCustomer.controls['email'].touched">
              <p *ngIf="formCustomer.get('email')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
              <p *ngIf="formCustomer.get('email')?.hasError('email')" class="text-red-600 text-xs font-bold">
                Formato no
                válido
              </p>
            </div>
          </div>
          <div class="flex flex-row justify-end">
            <button (click)="saveCustomer()"
              class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-8 w-40 px-6 hover:bg-[#27368A]">
              Guardar
            </button>
          </div>
        </div>
      </form>
    </p-dialog>
    <!---------------------------------------------MODAL DIRECCIÓN------------------------------------------------>
    <p-dialog [modal]="true" [(visible)]="formSteps['addressCustomerForm']" [style]="{width: '50%'}"
      [breakpoints]="{ '1900px': '75%' }" header="Dirección del titular">
      <form [formGroup]="formAddressCustomer">
        <ng-template pTemplate="header">
          <h4 class="text-[#27368A] font-extrabold text-xl flex place-items-center">Dirección</h4>
        </ng-template>
        <div class="grid grid-cols-2 gap-10 justify-center">
          <div class=" flex flex-col">
            <div class="mb-2">
              <label for="street_name" class="text-[#27368A] font-bold text-base">
                Nombre de la calle:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('street_name')?.touched && formAddressCustomer.get('street_name')?.hasError('required')}"
                formControlName="street_name" type="text" placeholder="Nombre de la calle" tabindex="2"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['street_name'].touched">
                <p *ngIf="formAddressCustomer.get('street_name')?.hasError('required')"
                  class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <div class="mb-2">
              <label for="street_number" class="text-[#27368A] font-bold text-base">
                Número:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('street_number')?.touched && formAddressCustomer.get('street_number')?.hasError('required')}"
                formControlName="street_number" type="text" placeholder="Numero de la calle" tabindex="3"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['street_number'].touched">
                <p *ngIf="formAddressCustomer.get('street_number')?.hasError('required')"
                  class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <label for="floor" class="text-[#27368A] font-bold text-base">
              Piso:
            </label>
            <input formControlName="floor" type="text" placeholder="piso" tabindex="4"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full mb-2 ">
            <label for="description" class="text-[#27368A] font-bold text-base">
              Letra/Descripción:
            </label>
            <input formControlName="description" type="text" placeholder="Letra/Descripción" tabindex="5"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
          </div>
          <div class="flex flex-col">
            <div class="mb-2">
              <label for="city" class="text-[#27368A] font-bold text-base">
                Ciudad:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('city')?.touched && formAddressCustomer.get('city')?.hasError('required')}"
                formControlName="city" type="text" placeholder="Ciudad" tabindex="6"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['city'].touched">
                <p *ngIf="formAddressCustomer.get('city')?.hasError('required')" class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <label for="province" class="text-[#27368A] font-bold text-base">
              Provincia:
            </label>
            <input formControlName="province" type="text" placeholder="Provincia" tabindex="7"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full mb-2 ">
            <div class="mb-2">
              <label for="country" class="text-[#27368A] font-bold text-base">
                País:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('country')?.touched && formAddressCustomer.get('country')?.hasError('required')}"
                formControlName="country" type="text" placeholder="País" tabindex="8"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['country'].touched">
                <p *ngIf="formAddressCustomer.get('country')?.hasError('required')"
                  class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <div class="mb-2">
              <label for="postal_code" class="text-[#27368A] font-bold text-base">
                Código postal:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('postal_code')?.touched && formAddressCustomer.get('postal_code')?.hasError('required')}"
                formControlName="postal_code" type="text" placeholder="Código postal" tabindex="9"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['postal_code'].touched">
                <p *ngIf="formAddressCustomer.get('postal_code')?.hasError('required')"
                  class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <div class="flex justify-end  mt-4">
              <div *ngIf="warningMessage" class="text-red-600 text-xs font-bold flex align-middle items-center">
                {{ warningMessage }}
              </div>
              <button (click)="saveAddressCustomer()" type="submit"
                class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-9 w-32 px-6 ml-4 hover:bg-[#27368A]">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </form>
    </p-dialog>



    <!-- <div class="p-dropdown-container flex content-center w-[100%] text-center">
      <p-dropdown [options]="tickets" [(ngModel)]="selectedTicket" optionLabel="serial"
        styleClass="w-[100%] p-dropdown-aux" (onChange)="onChangeSelectTicket($event)" [filter]="true"
        filterBy="serial" [showClear]="true" [placeholder]="placeholderTextTicketList">
        <ng-template pTemplate="selectedItem">
          <div class="flex align-items-center gap-2" *ngIf="selectedTicket">
            <div>Ticket: {{ selectedTicket.serial }}</div>
          </div>
        </ng-template>
        <ng-template let-ticketItem pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>Ticket: {{ ticketItem.serial }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div> -->
    <ng-container *ngIf="ticket">
      <div class="mb-7">
        <h2 class="text-center font-bold text-[40px]">Ticket: {{ ticket.serial }}</h2>
      </div>
  
      <div>
        <!---------------------------------------------DATOS------------------------------------------------>
        <div class="grid grid-cols-5 gap-3 mb-4">
          <div class="col-span-2">
            <div class="grid grid-cols-2">
              <div class="mb-4">
                <div class="flex flex-row gap-3">
                  <p class="text-[#27368A] font-extrabold text-lg">Datos Titular</p>
                  <button *ngIf="!hideAddCustomer" (click)="toggleForm('customerDataForm')"
                    class="text-white font-bold text-base flex justify-center align-middle items-center bg-black rounded-lg h-6 w-6 p-1 hover:bg-[#27368A]">
                    +
                  </button>
                </div>
  
                <ng-container *ngIf="selectedCustomer">
                  <div class="flex flex-wrap">
                    <p class="text-[#8A8A8A] font-bold text-base mr-1">Nombre completo:</p>
                    <p class="text-[#8A8A8A] text-base">
                      {{selectedCustomer?.name}}
                    </p>
                  </div>
                  <div class="flex flex-row gap-1">
                    <p class="text-[#8A8A8A] font-bold text-base">DNI:</p>
                    <p class="text-[#8A8A8A] text-base">
                      {{selectedCustomer?.cif}}
                    </p>
                  </div>
                  <div class="flex flex-row gap-1">
                    <p class="text-[#8A8A8A] font-bold text-base">Teléfono:</p>
                    <p class="text-[#8A8A8A] text-base">
                      {{selectedCustomer?.phone}}
                    </p>
                  </div>
                  <div class="flex flex-row gap-1">
                    <p class="text-[#8A8A8A] font-bold text-base">Email:</p>
                    <p class="text-[#8A8A8A] text-base">
                      {{selectedCustomer?.email}}
                    </p>
                  </div>
                </ng-container>
              </div>
              <div *ngIf="selectedCustomer" class="mb-4">
                <div class="flex flex-row gap-3">
                  <p class="text-[#27368A] font-extrabold text-lg">Dirección</p>
                  <button *ngIf="!hideAddAddress" (click)="toggleForm('addressCustomerForm')"
                    class="text-white font-bold text-base flex justify-center align-middle items-center bg-black rounded-lg h-6 w-6 p-1 hover:bg-[#27368A]">
                    +
                  </button>
                </div>
                <ng-container *ngFor="let address of selectedCustomer.addresses">
                  <div class="grid grid-cols-8">
                    <div class="col-span-7 flex flex-wrap">
                      <p class="text-[#8A8A8A] font-bold text-base mr-1">
                        {{address?.alias }}:
                      </p>
                      <p class="text-[#8A8A8A] text-base text-clip">
                        {{address?.street_name}}
                        {{ address?.street_number }}
                        {{ address?.floor }}
                        {{ address?.description }}
                        {{ address?.city }}-
                        {{ address?.province }}
                        {{ address?.country }}
                        {{ address?.postal_code }}
                      </p>
                      <p class="text-[#8A8A8A] text-base text-clip">
                        {{selectedCustomer?.address }}
                      </p>
                    </div>
                    <div class="col-span-1 flex flex-row  gap-2" *ngIf="!hideAddAddress">
                      <button (click)="editAddress(address)" pInputText>
                        <i class="pi pi-pencil" style="font-size: 0.2rem" style="color: #27368A"></i>
                      </button>
                      <button (click)="deleteAddress(address)" pInputText>
                        <i class="pi pi-times" style="font-size: 0.2rem" style="color: red"></i>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div *ngIf="(!selectedCustomer || selectedCustomer === undefined)" (click)="toggleForm('customerDataForm')"
              class="flex justify-center items-center w-full bg-slate-200 border border-dashed border-slate-500 rounded-xl hover:cursor-pointer  p-40">
              <h1 class="text-center text-2xl text-slate-500">
                Selecciona o crea un cliente<br>
                pulsando aquí
              </h1>
            </div>
            <div *ngIf="selectedCustomer">
              <p class="text-[#27368A] font-extrabold text-lg mr-1">
                Datos de facturación
              </p>
              <ng-container *ngIf="selectedCustomer">
                <div class="flex flex-wrap ">
                  <p class="text-[#8A8A8A] font-bold text-base">Razón social:</p>
                  <p class="text-[#8A8A8A] text-base">
                    {{ selectedCustomer?.name }}
                  </p>
                </div>
                <div class="flex flex-row gap-1">
                  <p class="text-[#8A8A8A] font-bold text-base">DNI/CIF:</p>
                  <p class="text-[#8A8A8A] text-base">
                    {{ selectedCustomer?.cif }}
                  </p>
                </div>
                <div class="flex flex-row gap-1">
                  <p class="text-[#8A8A8A] font-bold text-base">Teléfono:</p>
                  <p class="text-[#8A8A8A] text-base">
                    {{ selectedCustomer?.phone }}
                  </p>
                </div>
                <div class="flex flex-row gap-1">
                  <p class="text-[#8A8A8A] font-bold text-base">Email:</p>
                  <p class="text-[#8A8A8A] text-base">
                    {{ selectedCustomer?.email }}
                  </p>
                </div>
                <div class="flex flex-row gap-1">
                  <p class="text-[#8A8A8A] font-bold text-base">Dirección:</p>
                  <p class="text-[#8A8A8A] text-base">
                    <ng-container *ngIf="selectedCustomerFromDB">
                      {{getBillingAddress() }}
                    </ng-container>
                    <ng-container *ngIf="!selectedCustomerFromDB && selectedCustomer.addresses.length > 0">
                      {{getBillingAddress() }}
                    </ng-container>
                  </p>
                </div>
  
              </ng-container>
            </div>
          </div>
          <!---------------------------------------------DETALLES DE TICKET------------------------------------------------>
          <div class="col-span-3 h-full">
            <div class="flex flex-row gap-3">
              <p class="text-[#27368A] font-extrabold text-lg mb-2">Detalles de ticket</p>
            </div>
            <div class="w-full min-h-full">
  
              <table *ngIf="ticketDetails && ticketDetails.length > 0"
                class="w-full border-collapse border border-gray-200 my-2 text-left">
                <thead class="bg-gray-200">
                  <tr>
                    <th class="border border-gray-300 px-4 py-1 w-6">Concepto</th>
                    <th class="border border-gray-300 px-4 py-1">Unidades</th>
                    <th class="border border-gray-300 px-4 py-1">Subtotal</th>
                    <th class="border border-gray-300 px-4 py-1">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="ticketDetails && ticketDetails.length > 0; else noTicketDetailsMessage">
  
                    <tr *ngFor="let detail of ticketDetails; let i = index">
                      <td class="border border-gray-300 px-4 py-1 truncate ...">
                        {{ detail.concept }}
                      </td>
                      <td class="border border-gray-300 px-2 py-1 h-8 text-center">
                        <div class="input-units justify-center">
                          <i *ngIf="!detail.lock_units ; else otherLess"
                            class="pi pi-minus-circle cursor-pointer hover:text-blue-500 justify-start"
                            (click)="decreaseUnits(i)"></i>
                          <ng-template #otherLess>
                            <i class="pi pi-minus-circle justify-start"></i>
                          </ng-template>
                          <input *ngIf="!detail.lock_units ; else otherInputTicket"
                            class="text-center text-sm w-16 hover:bg-slate-100 px-2 mx-2" placeholder=""
                            [(ngModel)]="ticketDetails[i].units" type="number" min="1" [value]="detail.units"
                            inputmode="numeric" pattern="[0-9]*" />
                          <ng-template #otherInputTicket>
                            <input class="text-center text-sm hover:bg-slate-100 px-2 w-16 mx-2" placeholder=""
                              [(ngModel)]="ticketDetails[i].units" readonly type="number" min="1" [value]="detail.units"
                              pattern="[0-9]*" />
                          </ng-template>
                          <i *ngIf="!detail.lock_units ; else otherPlus"
                            class="pi pi-plus-circle cursor-pointer hover:text-blue-500 justify-end"
                            (click)="increaseUnits(i)"></i>
                          <ng-template #otherPlus>
                            <i class="pi pi-plus-circle justify-start"></i>
                          </ng-template>
                        </div>
                      </td>
                      <td class="border border-gray-300 px-4 py-1 text-base font-bold text-red-700">
                        {{ detail.unit_price * detail.units | currency:'EUR'}}
                      </td>
                      <td
                        class="border border-gray-300 px-4 py-1 text-sm font-bold text-red-700 cursor-pointer hover:text-red-400"
                        (click)="deleteTicketDetail(i)">
                        Eliminar
                      </td>
                    </tr>
                  </ng-container>
                  <ng-template #noTicketDetailsMessage class="border-b-2 ">
                    <p class="font-extralight text-[#8A8A8A]">
                      Aún no hay detalles del ticket
                    </p>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </div>
  
        </div>
        <div class="fixed bottom-0 left-0 right-0 z-50 w-full flex justify-center h-auto">
          <button (click)="saveInvoiceTicket()" type="submit" [disabled]="!isValidTicket() || saving"
            class="save_booking text-white font-bold text-2xl bg-black w-96 h-16 disabled:cursor-not-allowed hover:bg-[#27368A]">
            {{ saving ? 'Guardando...' : 'Generar factura'}}
          </button>
        </div>
        <div class="fixed bottom-0 left-0 z-40 w-full flex justify-end mb-4 bg-white">
          <p class="text-[#27368A] font-extrabold text-2xl mr-2 pt-1">Importe total</p>
          <p class="text-[#8A8A8A] font-extrabold text-4xl mr-5 text-red-700">
            {{ calculateTotalTicket() | currency: 'EUR' }}
          </p>
        </div>
      </div>
    </ng-container>
  </div>
</div>